import { useQuery } from '@apollo/client';
import { FETCH_COMPANY_REVENUE } from '../queries';
import { Spinner } from '../../../components';
import { useLocation, useSearchParams } from 'react-router-dom';
import { FETCH_LOCATION_COMPANY_REVENUE } from '../queries/RiskHub';
import FinancialData from '../../../components/common/FinancialData';
import NoAvailableData from '../../../components/assets/NoAvailableData';
import QueryErrorBoundary from '../../../components/error-handling';

type CompanyRevenueMapped = {
  totalPercentage: number;
  totalRevenue: number;
};

export function CompanyRevenueCard() {
  let [searchParams] = useSearchParams();
  const location = useLocation();
  const divisionUuid = searchParams.get('division');
  const locationUuid = searchParams.get('location');

  const pathname = location.pathname;
  const IS_LOCATION_RISK_HUB = pathname === '/location-risk-hub';

  const query = IS_LOCATION_RISK_HUB
    ? FETCH_LOCATION_COMPANY_REVENUE
    : FETCH_COMPANY_REVENUE;

  const { data, loading, error } = useQuery(query, {
    variables: {
      filter: IS_LOCATION_RISK_HUB ? { locationUuid } : { divisionUuid },
    },
  });

  const riskHubData = IS_LOCATION_RISK_HUB
    ? data?.companyRevenueMappedByLocation
    : data?.companyRevenueMapped;

  if (loading)
    return (
      <div className="flex items-center justify-center p-6">
        <Spinner />
      </div>
    );

  return (
    <QueryErrorBoundary error={error}>
      <div className="rounded-[10px] border border-secondary-100 overflow-hidden relative">
        <h2 className="text-sm text-primary-100 tracking-wider font-bold border-b border-secondary-100 bg-silver flex justify-center items-center">
          {IS_LOCATION_RISK_HUB
            ? '% Of Company Supported'.toUpperCase()
            : 'Company Revenue Mapped'.toUpperCase()}
        </h2>
        <div className="h-[200px] py-3 w-full flex flex-col items-center justify-between gap-2">
          {IS_LOCATION_RISK_HUB && !locationUuid ? (
            <NoAvailableData helpText="Select a location first" />
          ) : (
            <>
              <span className="font-bold text-center text-5xl text-blue tracking-wider">
                {riskHubData?.totalPercentage.toFixed(0)}%{' '}
              </span>
              <div className="flex flex-col">
                <span className="font-bold text-4xl text-primary-100 text-center">
                  {<FinancialData text={riskHubData.totalRevenue} />}
                </span>
                <span className="text-primary-100 text-xsm text-center font-light tracking-wider mt-auto">
                  Annual Revenue
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </QueryErrorBoundary>
  );
}
